import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { TokenSearchBar } from './mobile/TokenSearchBar';
import { TokenWithMetadata } from '@/hooks/explore/useTrendingTokens';
import { TokenResult } from '@/hooks/explore/useTokenSearch';
import classNames from '@/lib/misc/classNames';
import MobileMenu from '../shared/MobileMenu';
import TodayTopGainers from './mobile/TodayTopGainers';
import CashResults from './CashResult';
import LaunchPadView from './LaunchPadView';
import Loading from '@/components/shared/Loading';
import MobileResults from './MobileResults';
import { ModeValue } from '@shared/types/frontend/searchHome';
import { useSearchHome } from '@/contexts/SearchHomeProvider';
import MobileMemeMode from './mobile/MobileMemeMode';
import useAuthGuard from '@/hooks/auth/useAuthGuard';
import { Button } from '../ui/button';
import DepositHome from '../deposit/DepositHome';
import { useSession } from '@/contexts/LitSessionProvider';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import NormieCategories from './mobile/NormieCategories';
import RecentResults from './mobile/RecentResults';
import { MdArrowForward } from 'react-icons/md';
import Link from 'next/link';
import { Switch } from '../ui/switch';
import NetworkTimeSelector from './mobile/NetworkTimeSelector';
import MobileSearchResults from './MobileSearchResults';
import { IoIosArrowBack } from 'react-icons/io';
import { BiSolidUser } from 'react-icons/bi';
import useTokenNotifications from '@/hooks/asset/useTokenNotifications';
export type SearchPageProps = {
  setSelectToAsset?: (_bool: boolean) => void;
  onTokenClick?: (token: TokenResult | TokenWithMetadata) => void;
  backFunction?: () => void;
  className?: string;
  rowIsSelectedFunction?: (token: TokenResult | TokenWithMetadata) => boolean;
  desktop?: boolean;
  inputNetwork?: number[];
  isPopup?: boolean;
  startMode?: ModeValue;
};
export default function SearchHome({
  setSelectToAsset,
  className,
  onTokenClick,
  rowIsSelectedFunction
}: SearchPageProps) {
  const router = useRouter();
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: isLoadingAssetData
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const {
    keyword,
    setKeyword,
    network,
    timeFrame,
    subMode,
    setSubMode,
    subMemeData,
    resultsToUse,
    handleSearch,
    useUnprotectedSearch,
    setUseUnprotectedSearch,
    mode,
    setMode,
    allTokens,
    loadingModes,
    recentItems,
    showWildWest,
    wildWest,
    setNetwork,
    defaultNetwork,
    setTimeFrame,
    handleClearSavedTokens
  } = useSearchHome();
  const {
    isUserWithFunds,
    shouldOnboard,
    showReferralInput,
    hasUsername
  } = useAuthGuard();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const urlHasTrade = router.asPath?.includes('trade');
  useEffect(() => {
    urlHasTrade && setMode('memes');
  }, []);
  console.log('first results', {
    address: resultsToUse()?.[0]?.token?.address,
    network: resultsToUse()?.[0]?.token?.networkId
  });
  const {
    showOrder,
    animationKey
  } = useTokenNotifications({
    address: resultsToUse()?.[0]?.token?.address,
    network: resultsToUse()?.[0]?.token?.networkId
  });
  if (mode === 'saved') {
    if (loadingModes.loadingSavedTokens) {
      return <Loading className='p-4 h-6 w-6 my-1' />;
    } else {
      return <>
          <div className='flex items-center justify-between p-3'>
            <div>
              <div onClick={() => {
              setMode('recent');
            }} className='bg-genius-blue w-[68px] h-[38px] text-genius-cream text-[16px] rounded-full flex items-center cursor-pointer px-2'>
                <IoIosArrowBack className={`text-genius-cream`} />
                <p>Back</p>
              </div>
            </div>
            <div className='ta-c'>
              <p className='text-genius-cream text-[16px]'>Saved</p>
            </div>
            <div>
              <Button onClick={() => handleClearSavedTokens()} className='bg-genius-blue w-[67px] h-[38px] text-genius-cream text-[16px] rounded-full'>
                Clear
              </Button>
            </div>
          </div>
          <MobileSearchResults mode={mode} resultsToUse={resultsToUse} timeFrame={timeFrame} allTokens={allTokens} onTokenClick={onTokenClick} rowIsSelectedFunction={rowIsSelectedFunction} useUnprotectedSearch={useUnprotectedSearch} setUseUnprotectedSearch={setUseUnprotectedSearch} />
        </>;
    }
  }
  return <div className={classNames('bg-genius-indigo no-scrollbar h-screen pb-8', className)} data-sentry-component="SearchHome" data-sentry-source-file="SearchHome.tsx">
      <div className='w-full'>
        <TokenSearchBar onSearch={handleSearch} setSelectToAsset={onTokenClick ? setSelectToAsset : undefined} setMode={setMode} debouncedSearchTerm={keyword} mode={mode} startFocused={router.query.mode === 'search'} data-sentry-element="TokenSearchBar" data-sentry-source-file="SearchHome.tsx" />
      </div>

      {mode != '' && <div className='flex mt-4 justify-between px-4 text-genius-cream items-center  border-genius-blue border-y-[1px] py-4 '>
          <div className=''>Safe Search</div>
          <Switch checked={!wildWest} onClick={() => {
        showWildWest(!wildWest);
      }} />
        </div>}

      {mode === 'recent' || mode === 'memes' || mode === 'native' || mode === 'top' || mode === 'trending' || mode === 'gainers' || mode === 'new' || mode === 'cash' ? recentItems && recentItems.length > 0 ? <div className='my-6 border-genius-blue border-b-[1px]'>
            <RecentResults timeFrame={timeFrame} onTokenClick={onTokenClick} subMemeData={recentItems} network={network} />
          </div> : '' : !shouldOnboard && !showReferralInput && hasUsername && <div className={`ta-c w-full ${keyword === '' && 'pb-4 pt-2 border-genius-blue border-b-[1px]'}`}>
            {isUserWithFunds ? isLoadingAssetData ? <Loading className='p-4 h-6 w-6 my-1' /> : keyword === '' && !urlHasTrade ? <Link href='/portfolio'>
                  <div className='ta-l pl-2 hover:bg-genius-blue w-[95%] rounded-md py-2 flex justify-between items-center'>
                    <p className='text-[32px] text-genius-cream'>
                      $
                      {assetData.totalUsdValue.toLocaleString(undefined, {
              maximumFractionDigits: 2
            })}
                    </p>
                    <div>
                      <MdArrowForward className={'w-[20px] h-[20px] text-genius-cream/50 mr-4'} />
                    </div>
                  </div>
                </Link> : '' : <>
                <Button onClick={() => {
          setIsModalOpen(true);
        }} variant='pink' className='w-[90%] m-auto rounded-full h-[56px]'>
                  Deposit Cash or Crypto
                </Button>
                <DepositHome isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
              </>}
          </div>}
      <div className={`flex
          w-full 
          gap-1.5 items-center           
          border-genius-blue
          overflow-x-auto no-scrollbar pl-2`}>
        <NetworkTimeSelector network={network} defaultNetwork={defaultNetwork} setNetwork={setNetwork} timeFrame={timeFrame} setTimeFrame={setTimeFrame} data-sentry-element="NetworkTimeSelector" data-sentry-source-file="SearchHome.tsx" />
      </div>

      {(mode === 'recent' || mode === 'memes' || mode === 'native' || mode === 'top' || mode === 'gainers' || mode === 'new' || mode === 'trending' || mode === 'cash' && keyword === '') && <>
          <NormieCategories setKeyword={setKeyword} mode={mode} setMode={setMode} />
        </>}

      {(mode == 'trending' || mode === 'gainers' || mode === 'new') && <div className='px-4 text-[12px] text-genius-cream p-4 border-red-400 border-[1px] rounded-[20px] bg-[#F8717126] mx-4'>
          Trending tokens are algorithmically sourced from on-chain data. They are not vetted for
          honeypots or scams. Genius is not responsible for lost funds. Exercise caution when
          trading.
        </div>}

      {(mode === 'memes' || mode === 'recent') && <>
          <MobileMemeMode setMode={setMode} subMode={subMode} setSubMode={setSubMode} timeFrame={timeFrame} subMemeData={subMemeData} network={network} />
        </>}

      {(mode === 'memes' || mode === '') && !(loadingModes.subMemeLoading && mode === 'memes') && !(loadingModes.subMemeLoading && mode === '') && <>
            <div className='border-genius-blue border-b-[1px] py-4'>
              {/* <div className='px-4 text-[12px] my-2  text-genius-cream p-4 border-red-400 border-[1px] rounded-[20px] bg-[#F8717126] mx-4'>
                The Solana Blockchain is experiencing high congestion. Buys, sells and transfers may
                not execute for Solana tokens.
               </div> */}
              <p className='text-[16px] text-genius-gradient flex items-center pl-4 mt-1'>
                Recently Listed
              </p>

              <div className='gradient-genius-sides mx-3 my-6 mb-8 rounded-[12px] border-genius-blue border-[1px] relative'>
                <MobileSearchResults mode={mode} resultsToUse={() => {
            return resultsToUse()?.slice(0, 1);
          }} timeFrame={timeFrame} allTokens={allTokens} onTokenClick={onTokenClick} rowIsSelectedFunction={rowIsSelectedFunction} useUnprotectedSearch={useUnprotectedSearch} setUseUnprotectedSearch={setUseUnprotectedSearch} />
                {showOrder && <span key={animationKey} // Use animation key to re-trigger animations
          className={`absolute bottom-[-38px] left-[0px] w-fit h-[26px] text-[12px] text-black rounded-full px-3 flex items-center bg-[${showOrder.type === 'buy' ? '#34D399' : '#F87171'}] fade-animation`}>
                    <BiSolidUser className='mr-1' />
                    {showOrder.type === 'buy' ? `Buy: ${showOrder.amount}` : `Sell: ${showOrder.amount}`}
                  </span>}
              </div>
            </div>
          </>}

      {mode === '' && <div className='my-6 border-genius-blue border-b-[1px]'>
          <TodayTopGainers timeFrame={timeFrame} onTokenClick={onTokenClick} subMemeData={subMemeData} network={network} loading={loadingModes.gainerLoading} />
        </div>}

      {mode === '' && <p className='text-[16px] text-genius-gradient flex items-center pl-4 mt-4'>Trending</p>}
      <div className={`w-full no-scrollbar overflow-auto mt-2 pb-[130px]`}>
        {loadingModes.isLoading && mode === 'search' || loadingModes.subMemeLoading && mode === 'memes' || loadingModes.nativeTokensDataLoading && mode === 'native' || loadingModes.gainerLoading && mode === 'gainers' || loadingModes.topLoading && mode === 'top' || loadingModes.trendingLoading && mode === 'trending' || loadingModes.loserLoading && mode === 'losers' || loadingModes.newLoading && mode === 'new' || loadingModes.subMemeLoading && mode === '' ? <div className='h-[10vh] w-full flex items-center flex-col justify-center'>
            <Loading className=' h-8 w-8' />
          </div> : mode === 'cash' ? <CashResults onTokenClick={onTokenClick} /> : mode == 'launchpad' ? <LaunchPadView /> : <MobileSearchResults mode={mode} resultsToUse={() => {
        return mode === '' || mode == 'memes' ? resultsToUse()?.sort((a, b) => parseFloat(b?.['volume' + timeFrame]) - parseFloat(a?.['volume' + timeFrame])) : resultsToUse();
      }} timeFrame={timeFrame} allTokens={allTokens} onTokenClick={onTokenClick} rowIsSelectedFunction={rowIsSelectedFunction} useUnprotectedSearch={useUnprotectedSearch} setUseUnprotectedSearch={setUseUnprotectedSearch} />}

        <MobileMenu hasShadow={true} data-sentry-element="MobileMenu" data-sentry-source-file="SearchHome.tsx" />
      </div>
    </div>;
}